import React, { Component, memo } from "react";
import TableHeader from "./TableHeader";
import { randomKey } from "utils/randomKey";
import BootstrapTable from "react-bootstrap-table-next";
import CachedIcon from "@material-ui/icons/Cached";
import moment from "moment";
import "./style.css";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import GstnTableValidation from "./GstinValidationTable";
import { connect } from "react-redux";
import { compose } from "redux";
import { getGstnValidationSummay, getGstrTrackSummay } from "./action";
const headerColumns = [
  {
    value: "GSTIN Detail",
    id: "1",
  },
  {
    value: "Filing Status",
    id: "2",
  },
];

const rowStyle2 = (row, rowIndex) => {
  const style = {};
  style.backgroundColor = "#fff";
  return style;
};
const displayNullFormatter = (row, property) => {
  return (
    <>
      {row[property] === null ||
      row[property] === undefined ||
      row[property] === ""
        ? "--"
        : row[property]}
    </>
  );
};
const filingColumns = [
  {
    dataField: "fillingPeriod",
    text: "Filing Period",
    style: (cell, row, rowIndex, colIndex) => {
      const fontFamily = "Gt-Walsheim-medium";
      const fontSize = "11px";
      const fontWeight = "bold";
      const textAlign = "center";
      const width = '50%';
      return { fontFamily, fontSize, fontWeight, textAlign,width };
    },
    headerStyle: {
      fontFamily: "Gt-Walsheim-medium",
      fontSize: "12px",
      fontWeight: "bold",
      verticalAlign: "text-top",
      textAlign: "center",
    },

    formatter: (cell, row) => displayNullFormatter(row, "fillingPeriod"),
  },
  {
    dataField: "GSTR1",
    text: "GSTR 1",
    style: (cell, row, rowIndex, colIndex) => {
      const fontFamily = "Gt-Walsheim-medium";
      const fontSize = "11px";
      const fontWeight = "bold";
      const textAlign = "center";
      const width = '25%';

      return { fontFamily, fontSize, fontWeight, textAlign,width };
    },
    headerStyle: {
      fontFamily: "Gt-Walsheim-medium",
      fontSize: "12px",
      fontWeight: "bold",
      verticalAlign: "text-top",
      textAlign: "center",
    },
    formatter: (cell, row) => {
      const value = row["GSTR1"];
      if (value === null || value === undefined || value === "") {
        return "--";
      }
      // Check if the value is a valid date in yyyy-mm-dd format
      if (moment(value, "YYYY-MM-DD", true).isValid()) {
        return moment(value, "YYYY-MM-DD").format("DD-MM-YYYY");
      }
      return value;
    },

  },
  {
    dataField: "GSTR3B",
    text: "GSTR 3B",
    style: (cell, row, rowIndex, colIndex) => {
      const fontFamily = "Gt-Walsheim-medium";
      const fontSize = "11px";
      const fontWeight = "bold";
      const textAlign = "center";
            const width = '50%';

      return { fontFamily, fontSize, fontWeight, textAlign,width };
    },
    headerStyle: {
      fontFamily: "Gt-Walsheim-medium",
      fontSize: "12px",
      fontWeight: "bold",
      verticalAlign: "text-top",
      textAlign: "center",
    },
     formatter: (cell, row) => {
      const value = row["GSTR3B"];
      if (value === null || value === undefined || value === "") {
        return "--";
      }
      // Check if the value is a valid date in yyyy-mm-dd format
      if (moment(value, "YYYY-MM-DD", true).isValid()) {
        return moment(value, "YYYY-MM-DD").format("DD-MM-YYYY");
      }
      return value;
    },


  },
  // {
  //   dataField: "GSTR9",
  //   text: "GSTR9",
  //   style: (cell, row, rowIndex, colIndex) => {
  //     const fontFamily = "Gt-Walsheim-medium";
  //     const fontSize = "11px";
  //     const fontWeight = "bold";
  //     const textAlign = "center";
  //     return { fontFamily, fontSize, fontWeight, textAlign };
  //   },
  //   headerStyle: {
  //     fontFamily: "Gt-Walsheim-medium",
  //     fontSize: "12px",
  //     fontWeight: "bold",
  //     verticalAlign: "text-top",
  //     textAlign: "center",
  //   },
  // },

  // {
  //   dataField: "GSTR9C",
  //   text: "GSTR9C",
  //   style: (cell, row, rowIndex, colIndex) => {
  //     const fontFamily = "Gt-Walsheim-medium";
  //     const fontSize = "11px";
  //     const fontWeight = "bold";
  //     const textAlign = "center";
  //     return { fontFamily, fontSize, fontWeight, textAlign };
  //   },
  //   headerStyle: {
  //     fontFamily: "Gt-Walsheim-medium",
  //     fontSize: "12px",
  //     fontWeight: "bold",
  //     verticalAlign: "text-top",
  //     textAlign: "center",
  //   },
  // },
  // {
  //   dataField: "GSTR2X",
  //   text: "GSTR2X",
  //   style: (cell, row, rowIndex, colIndex) => {
  //     const fontFamily = "Gt-Walsheim-medium";
  //     const fontSize = "11px";
  //     const fontWeight = "bold";
  //     const textAlign = "center";
  //     return { fontFamily, fontSize, fontWeight, textAlign };
  //   },
  //   headerStyle: {
  //     fontFamily: "Gt-Walsheim-medium",
  //     fontSize: "12px",
  //     fontWeight: "bold",
  //     verticalAlign: "text-top",
  //     textAlign: "center",
  //   },
  // },
];

// const data = [
//     {
//         key: 'GSTIN Status',
//         value: 'Active'
//     },
//     {
//         key: 'E-invoice Status',
//         value: 'Active'
//     },
//     {
//         key: 'Legal Name Of Business',
//         value: 'ABC College'
//     },
//     {
//         key: 'Trade Name',
//         value: 'ABC College'
//     },
//     {
//         key: 'Date Of Registration',
//         value: '42910'
//     },
//     {
//         key: 'Taxpayer Type',
//         value: 'Regular'
//     },
//     {
//         key: 'Constitution Of Business',
//         value: 'Trust'
//     },
//     {
//         key: 'Nature Of Business Activities',
//         value: 'Retail Business'
//     },
//     {
//         key: 'Center Jurisdicion',
//         value: 'Range-II'
//     },
//     {
//         key: 'Last Fetch Date And Time',
//         value: '4190'
//     },
// ]
const data = [
  {
    filing_period: "Aug-23",
    gstr1_date: "09-09-2023",
    gstr3b_date: "01-09-2023",
  },
  {
    filing_period: "Aug-23",
    gstr1_date: "09-09-2023",
    gstr3b_date: "01-09-2023",
  },
  {
    filing_period: "Aug-23",
    gstr1_date: "09-09-2023",
    gstr3b_date: "01-09-2023",
  },
  {
    filing_period: "Aug-23",
    gstr1_date: "09-09-2023",
    gstr3b_date: "01-09-2023",
  },
  {
    filing_period: "Aug-23",
    gstr1_date: "09-09-2023",
    gstr3b_date: "01-09-2023",
  },
  {
    filing_period: "Aug-23",
    gstr1_date: "09-09-2023",
    gstr3b_date: "01-09-2023",
  },
];

class GstinFilingModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ret_period:"",
      activeTab: 1,
      gstinDetailData: {},
      filingData: {},
    };
    this.handleTabChange = this.handleTabChange.bind(this);
    // this.errorNot = this.errorNot.bind(this);
    // this.errorNotErr = this.errorNotErr.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onChangeFy = this.onChangeFy.bind(this);
    this.onClickRefresh = this.onClickRefresh.bind(this);
    this.convertRetperiodToFyFormat =
      this.convertRetperiodToFyFormat.bind(this);
  }
  async handleTabChange(id) {
    await this.setState({
      activeTab: id,
    });
  }

  convertRetperiodToFyFormat(inputDate) {
    // Parse the input date
    const parts = inputDate.split("-");
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[1], 10);

    // Create a Date object with the parsed values
    const dateObject = new Date(year, month - 1, 1); // Month is zero-based

    // Format the date in the desired way
    const formattedDate = `${dateObject.getFullYear()}-${(
      dateObject.getFullYear() + 1
    )
      .toString()
      .substring(2)}`;

    return formattedDate;
  }

  onDateChange = (props) => {
    let date = new Date(props);
    // console.log("date", date);
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    if (month < 10) {
      month = "0" + month;
    }
    let val = month + "-" + year;
    // console.log(val);
    this.setState({
      ret_period: props == null ? "" : val,
    });

    // await this.props.fetchProgress(undefined, val);
  };

  async componentDidMount() {
    // console.log(this.props.gstnValidationData, "componentDidMount");
    // this.props.getGstrTrackSummay(this.props.dedgstin, this.state.ret_period);
    // console.log('this.props.gstrTrackSummary.reverse()::',this.props.gstrTrackSummary.reverse())
    if (this.props.dedgstin) {
      let data = await this.props.getGstnValidationSummay(this.props.dedgstin);
      this.setState({
        gstinDetailData: data,
      });
    }

    if (this.props.dedgstin &&  this.props.fyear) {
      {
        let fy = this.convertRetperiodToFyFormat( this.props.fyear);

        let filingData = await this.props.getGstrTrackSummay(this.props.dedgstin, fy);
        this.setState({
          filingData: filingData,
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
     console.log('this.props.gstrTrackSummary.reverse()::',this.props.gstrTrackSummary.reverse())
    // console.log(
    //   this.props.gstnValidationData,
    //   "componentDidUpdategstnValidationData"
    // );

    // if (prevState.activeTab != this.state.activeTab) {
    //   if (this.state.activeTab == 1) {
    //     if (this.props.dedgstin != prevProps.dedgstin) {
    //       this.props.getGstnValidationSummay(this.props.dedgstin);
    //     }
    //   } else {
    //     if (this.props.dedgstin && this.state.ret_period) {
    //       if (
    //         this.props.dedgstin != prevProps.dedgstin ||
    //         prevState.ret_period != this.state.ret_period
    //       ) {
    //         let fy = this.convertRetperiodToFyFormat(this.state.ret_period);

    //         this.props.getGstrTrackSummay(this.props.dedgstin, fy);
    //       }
    //     }
    //   }
    // }
  }

  async onChangeFy(event) {
    // console.log(event, "event inm value");
    this.setState({
      ret_period: event.value,
    });
    if (this.props.dedgstin && event.value) {
      //let fy = this.convertRetperiodToFyFormat(event.value);
      let filingData = await this.props.getGstrTrackSummay(this.props.dedgstin, event.value);
        this.setState({
          filingData: filingData,
      });
    }
  }

  onClickRefresh() {
    // console.log("onClickRefresh");

    let ret_period=   this.state.ret_period||this.convertRetperiodToFyFormat(this.props.fyear)
    if (this.state.activeTab == 1) {
      if (this.props.dedgstin) {
        this.props.getGstnValidationSummay(this.props.dedgstin, true);
      }
    } else {
      if (this.props.dedgstin && ret_period) {
        //let fy = this.convertRetperiodToFyFormat(this.state.ret_period);

        this.props.getGstrTrackSummay(
          this.props.dedgstin,
          ret_period,
          true
        );
      }
    }
  }

  render() {
    return (
      <div>
        <div style={{ display: "flex" }}>
          <div style={{ width: "45%" }}>
            <TableHeader
              handleTabChange={this.handleTabChange}
              columns={headerColumns}
              activeTab={this.state.activeTab}
            />
          </div>
          {this.state.activeTab == 2 &&
            <div
            style={{ width: "20%", padding: "1.7em" }}
            onClick={this.onClickRefresh}
          >
            <span style={{ fontSize: "9px" }}>Refresh</span>{" "}
            <CachedIcon style={{ cursor: "pointer" }} />
          </div>
          }
        </div>
        {/* <div id="table-wrapper-prog">
        <div id="table-scroll"> */}
         {this.state.activeTab == 2 ? (
            <div
              className="dateContainer"
              style={{ width: "35%", }}
            >
              <Container
                data={[
                  {
                    label: "2020-2021",
                    value: "2020-21",
                  },
                  {
                    label: "2021-2022",
                    value: "2021-22",
                  },
                  {
                    label: "2022-2023",
                    value: "2022-23",
                  },
                  {
                    label: "2023-2024",
                    value: "2023-24",
                  },
                  {
                    label: "2024-2025",
                    value: "2024-25",
                  },
                ]}
                mode="simpleSelect"
                onChange={this.onChangeFy}
              />
            </div>
          ) : (
            <></>
          )}
        {this.state.activeTab == 1 ? (
          <GstnTableValidation
            data={
              this.props.gstnValidationData &&
              this.props.gstnValidationData.length
                ? this.props.gstnValidationData[0]
                : {}
            }
            gstinDetailData={this.state.gstinDetailData}
          />
        ) : this.props.gstrTrackSummary.length > 0 ?
          (
          <div id="table-wrapper-prog">
          <div id="table-scroll-filing-gstr7">
            <BootstrapTable
              keyField={randomKey()}
              // data={this.props.gstrTrackSummary.reverse()}
               data={this.props.gstrTrackSummary}
              columns={filingColumns}
              rowStyle={rowStyle2}
            />
            </div>
            </div>
        ): (this.state.filingData.error == 1)?
        <div style={{width:"100%", height:"200px", display:"flex", justifyContent:"center", alignItems: "center", fontWeight:"800", fontSize:"16px"}}>
          <div>{this.state.filingData.message}</div>
        </div>
        :
        <div style={{width:"100%", height:"200px", display:"flex", justifyContent:"center", alignItems: "center", fontWeight:"800", fontSize:"16px"}}>
          <div>No data found</div>
        </div>
      }

        {/* <BootstrapTable
          keyField={randomKey()}
          data={
            this.state.activeTab == 1
              ? this.props.gstnValidationData
              : this.props.gstrTrackSummary
          }
          columns={this.state.activeTab == 1 ? gstinColumns : filingColumns}
          rowStyle={rowStyle2}
        /> */}

        {/* </div>
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    gstrTrackSummary:state.gstinFilingReducer.trackReturn,
    gstnValidationData:state.gstinFilingReducer.validatonData,
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    getGstnValidationSummay: (gstin,isRefresh) => dispatch(getGstnValidationSummay(gstin,isRefresh)),
    getGstrTrackSummay:(gstin,fy,isRefresh)=>dispatch(getGstrTrackSummay(gstin,fy,isRefresh)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(GstinFilingModal);
